module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n      Case Crew\n    ")])], 1), _vm._v(" "), _c('v-list', {
    staticClass: "no-padding"
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "auth-height",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Shifting Crew")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('v-select', {
    staticClass: "case-crew-select",
    attrs: {
      "disabled": _vm.disabled.caseCrewSelect || _vm.closed,
      "items": _vm.filterPallBearers(_vm.servicesList, 0),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "disabled": ""
    },
    on: {
      "blur": function($event) {
        return _vm.updatePallbearers(0)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }]),
    model: {
      value: (_vm.selectedShiftingCrew),
      callback: function($$v) {
        _vm.selectedShiftingCrew = $$v
      },
      expression: "selectedShiftingCrew"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "no-padding"
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "auth-height",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Sending Crew")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('v-select', {
    staticClass: "case-crew-select",
    attrs: {
      "disabled": _vm.disabled.caseCrewSelect || _vm.closed,
      "items": _vm.filterPallBearers(_vm.servicesList, 1),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "disabled": ""
    },
    on: {
      "blur": function($event) {
        return _vm.updatePallbearers(1)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }]),
    model: {
      value: (_vm.selectedSendingCrew),
      callback: function($$v) {
        _vm.selectedSendingCrew = $$v
      },
      expression: "selectedSendingCrew"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "no-padding"
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "auth-height",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Funeral Crew")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('v-select', {
    staticClass: "case-crew-select",
    attrs: {
      "disabled": _vm.disabled.caseCrewSelect || _vm.closed,
      "items": _vm.filterPallBearers(_vm.servicesList, 2),
      "item-text": "description",
      "attach": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "disabled": ""
    },
    on: {
      "blur": function($event) {
        return _vm.updatePallbearers(2)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n          ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n                " + _vm._s(props.item.name) + " - " + _vm._s(props.item.description) + "\n              ")])])]
      }
    }]),
    model: {
      value: (_vm.selectedFuneralCrew),
      callback: function($$v) {
        _vm.selectedFuneralCrew = $$v
      },
      expression: "selectedFuneralCrew"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6248cf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CaseCrewDataTable.vue
// module id = 1038
// module chunks = 1